export const activeSeasons = [2024, 2023];
